export default "__VITE_ASSET__BpqXas4l__"